import { render, staticRenderFns } from "./bind-phone.vue?vue&type=template&id=6f83106c&"
import script from "./bind-phone.vue?vue&type=script&lang=js&"
export * from "./bind-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports